/*
    Hook diseñado para forzar la desactivación del autocompletado del navegador (Chrome, gestores de contraseñas,
    etc.) en los campos de un formulario.

    Puntos clave:
        Estrategia anti-Chrome (autoComplete="new-password"): Usa el token "new-password" y nombres 
        aleatorios únicos (name: "nf_email_1a2b3c") para engañar al algoritmo de Chrome y evitar que 
        despliegue sugerencias de datos personales guardados.

        Desactiva gestores externos: Añade atributos data-* para indicarle a herramientas como 1Password, 
        LastPass o Bitwarden que ignoren el campo.

        Limpia asistentes de escritura: Desactiva autocorrección, mayúsculas automáticas y corrector 
        ortográfico (autoCorrect, autoCapitalize, spellCheck).

        Modo estricto (hard: true): Marca el campo como readOnly: true al cargar y se lo quita únicamente al 
        hacer clic/foco (onFocus), bloqueando por completo el autocompletado en navegadores persistentes.
*/

import { useCallback, useRef } from "react";


export const useNoAutofill = ({ hard = false } = {}) => {

    const REF__key = useRef(Math.random().toString(36).slice(2, 8));

    return useCallback((field = "campo") => {

        const PROPS = {

            name: `nf_${field}_${REF__key.current}`,
            autoComplete: "new-password",

            autoCorrect: "off",  autoCapitalize: "off",  spellCheck: false,

            // 🎯 Banderas de los gestores de contrasenas externos.
            "data-lpignore": "true",
            "data-1p-ignore": "true",
            "data-bwignore": "true",
            "data-form-type": "other",
        };

        if (!hard) return PROPS;

        return {
            ...PROPS,   readOnly: true,  onFocus: (e) => e.target.removeAttribute("readonly"),
        };

    }, [hard]);
};
